exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".instructions {\n  margin-left: 1em; }\n\n.device-type-options > span {\n  margin-right: 1em; }\n  .device-type-options > span:last-of-type {\n    margin-right: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/ui/InstructionsComponent.scss
// module id = 134
// module chunks = 0